export const entityMemberManagement = {
  header: 'Super Admin Home',
  groupKey: 'entityMemberManagement',
  filters: [
    { text: 'Search Users', value: 'searchUsers' },
    // { text: 'Add New Organization / User', value: 'addOrganization' },
    { text: 'View Organizations', value: 'viewEntities' },
    { text: 'View Pending Request', value: 'pendingReqs' },
    { text: 'View Rejected Request', value: 'rejectedReqs' },
    { text: 'View Invited Orgs', value: 'viewInvited' },
    { text: 'View NFFS Orgs', value: 'viewNffs' },
    { text: 'View FIA Orgs', value: 'viewFia' },
    { text: 'Edit Banner', value: 'banner' },
  ],
};

export const siteManagement = {
  header: 'Site Management',
  groupKey: 'siteManagement',
  filters: [
    { text: 'View Activity Logs', value: 'viewLogs' },
    { text: `Manage How-to's`, value: 'managesHows' },
    { text: 'Update Licensing Agreements', value: 'updateLicensing' },
  ],
};

export const StdSpecManagement = {
  header: 'Std/Spec Management',
  groupKey: 'stdspecManagement',
  filters: [
    { text: 'Add/Edit Std/Spec', value: 'addStdSpec' },
    { text: 'Add/Edit Source', value: 'addSource' },
  ],
};



// WEBPACK FOOTER //
// ./src/config/searchFilters/SuperAdminFilters.js